"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isEmptyObject;

function isEmptyObject(obj) {
  return obj !== undefined && Object.keys(obj).length === 0;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/InternalDropdown/helpers/isEmptyObject.js
// module id = vNpm
// module chunks = 0